export class ApplicantPersonal {
    constructor (
        public RentalApplicationKey: number = null,
        public RentalApplicantKey: number = 0,
        public BirthDate: Date = null,
        public birthMonth: number = null,
        public birthDay: number = null,
        public birthYear: number = null,
        public SSN: string = '',
        public DLNum: string = '',
        public DLState: string = '',
        public RentalMaritalStatusKey: number = null,
        public NumChildren: number = null,
        public createdAt: Date = null,
        public updatedAt: Date = null,
        public Pets: {} = null,
        public Occupants: {} = null,
        public hasChildren: boolean = null,
        public hasPets: boolean = null,
        public CompletedByOther: boolean = false,
        public IsPrimary:boolean=false
    ) { }
}
